OE.addPlugin('Ajax', (function(){
    var Plugin = {},
        Options = {
            'post' : false,
            'onSuccess' : null,
            'onError' : null,
            'onStart' : null,
            'onStop' : null
        };

    Plugin.init = function()
    {
    };

    Plugin.request = function (url, options)
    {
        options = typeof options !== 'object' ? {} : options;
        url = typeof url !== 'string' ? null : url;

        if(url)
        {
            var request = new XMLHttpRequest();
            request.open(options.post ? 'POST' : 'GET', url, true);

            if(typeof options.headers === 'object')
            {
                for(var p in options.headers)
                {
                    request.setRequestHeader(p, options.headers[p]);
                }
            }

            request.onload = loadEvent.bind(request, options);
            request.onerror = errorEvent.bind(request, options);

            if(typeof options.onStart === 'function')
            {
                options.onStart(request);
            }

            request.send(options.data || null);
        }
    };

    var loadEvent = function(options, e)
    {
        if (this.status >= 200 && this.status < 400)
        {
            if(typeof options.onSuccess === 'function')
            {
                options.onSuccess(this);
            }
        }
        else
        {
            errorEvent.bind(this, options)();
        }

        if(typeof options.onStop === 'function')
        {
            options.onStop(this);
        }
    };

    var errorEvent = function(options, e)
    {
        if(typeof options.onError === 'function')
        {
            options.onError(this);
        }
    };

    return Plugin;
})());
